<!-- <formio-loader></formio-loader> -->
<div class="calendar-wrapper" *ngIf="isOpTionsReady$ | async">
	<full-calendar [options]="calendarOptions"  [deepChangeDetection]="true" #calendar></full-calendar>
</div>